export type CoordinateAnswerPair = [[number, number], any[]];

export enum SelectorType {
    COMPASS,
    MULTIPLE_CHOICE,
}
